import { render, staticRenderFns } from "./body-matchings.vue?vue&type=template&id=a6b17488&scoped=true"
import script from "./body-matchings.vue?vue&type=script&lang=js"
export * from "./body-matchings.vue?vue&type=script&lang=js"
import style0 from "./body-matchings.vue?vue&type=style&index=0&id=a6b17488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b17488",
  null
  
)

export default component.exports